export default {
  name: "Camera",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M27 7.17h-3.49l-2.4-3.34c-.37-.52-.98-.83-1.62-.83h-6.97c-.64 0-1.25.31-1.62.83L8.5 7.17H5c-1.1 0-2 .9-2 2V26c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V9.17c0-1.1-.9-2-2-2zM12.51 5h6.97l1.56 2.17h-10.1L12.51 5zM27 26H5V9.17h22V26zm-11-2c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm0-10c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z",
  },
}
